import { Suspense, lazy } from "react";
import Loader from "../customs/loader/main";
import Layout from "../components/dashboard/main";

const Main = lazy(() => import("../components/voting/candidateList/candidateList"));

const CandidateList = () => {
  return (
    // <Layout pageHeading="Voting">
      <Suspense fallback={<Loader />}>
        <Main />
      </Suspense>
    // </Layout>
  );
};

export default CandidateList;
